import React, { Component } from "react";
import "./Login.scss";
import axios from "axios";
import { IoCloseOutline as Close } from "react-icons/io5";
import { IoEye as Eye } from "react-icons/io5";
import { IoEyeOff as EyeOff } from "react-icons/io5";
import { Helmet } from "react-helmet-async";
import Logo from "img/logo/simple-logo.jpg";

class Login extends Component {
  state = { isPasswordHidden: true };

  goBack = () => {
    if (/* !this.props.location.state */ this.props.history.action !== "PUSH") {
      this.props.history.push("/");
    } else if (this.props.location.state) {
      this.props.history.go(-2);
    } else {
      this.props.history.goBack();
    }
  };

  _login = async () => {
    const { mail, password } = this.state;
    try {
      const response = await axios.post(
        "https://api.utilitalia.it/CMS/Account/Login",
        {
          username: mail,
          password,
        }
      );
      if (!response?.data?.data?.sessionId) {
        this.setState({
          loginError: true,
          errorType: response?.data?.data?.resultType?.toLowerCase(),
          errorMessage: response?.data?.data?.resultType
            .split(/(?=[A-Z])/)
            .join(" "),
        });
      } else {
        sessionStorage.setItem("sessionId", response?.data?.data?.sessionId);
        this.props.history.goBack();
      }
    } catch (err) {
      this.setState({
        loginError: true,
      });
    }
  };

  _resetPassword = async () => {
    const { mail, password, newpassword } = this.state;
    try {
      const response = await axios.post(
        "https://api.utilitalia.it/CMS/Account/LoginAndChangePassword",
        {
          username: mail,
          password,
          newpassword,
        }
      );
      if (!response?.data?.data?.sessionId) {
        this.setState({
          loginError: true,
          errorType: response?.data?.data?.resultType?.toLowerCase(),
          errorMessage: response?.data?.data?.resultType
            .split(/(?=[A-Z])/)
            .join(" "),
        });
      } else {
        sessionStorage.setItem("sessionId", response?.data?.data?.sessionId);
        this.goBack();
      }
    } catch (err) {
      this.setState({
        loginError: true,
      });
    }
  };

  _handleChangeInput = (target, value) => this.setState({ [target]: value });

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this._login(this.state.mail, this.state.password);
    }
  };

  render() {
    const passwordIsExpired = this.state.errorType
      ?.toLowerCase()
      .includes("expired");
    const passwordIsWeak = this.state.errorType?.toLowerCase().includes("weak");
    return (
      <div id="login">
        <Helmet>
          <title>Utilitalia</title>
          <link rel="icon" href={Logo} />
        </Helmet>

        <Close className="close" onClick={this.goBack} />

        <div className="content">
          <h6>Area Riservata</h6>
          <h2 className="general">
            Effettua il login <br />
            <span>per accedere all'area riservata</span>
          </h2>
          <div className="input">
            <input
              onKeyPress={this.handleKeyPress}
              onChange={(event) =>
                this._handleChangeInput("mail", event.target.value)
              }
              type="email"
              target="mail"
              placeholder="Indirizzo email/Username"
            />
            <div style={{ position: "relative" }}>
              <input
                onKeyPress={this.handleKeyPress}
                onChange={(event) =>
                  this._handleChangeInput("password", event.target.value)
                }
                type={this.state.isPasswordHidden ? "password" : "text"}
                target="password"
                id="password"
                placeholder="Password"
              />
              {this.state.isPasswordHidden ? (
                <Eye
                  className="eye"
                  onClick={() => this.setState({ isPasswordHidden: false })}
                />
              ) : (
                <EyeOff
                  className="eye"
                  onClick={() => this.setState({ isPasswordHidden: true })}
                />
              )}
            </div>
            {(passwordIsExpired || passwordIsWeak) && (
              <input
                onKeyPress={this.handleKeyPress}
                onChange={(event) =>
                  this._handleChangeInput("newpassword", event.target.value)
                }
                type="password"
                target="newpassword"
                id="newpassword"
                placeholder="Nuova Password"
              />
            )}
            {this.state.loginError && (
              <p
                style={{
                  color: "crimson",
                  textTransform: "uppercase",
                  textAlign: "center",
                  fontWeight: 500,
                }}
              >
                {passwordIsWeak
                  ? "Password troppo debole, inserire una nuova password"
                  : passwordIsExpired
                  ? "Password scaduta, inserire una nuova password"
                  : "Username o password errati"}
              </p>
            )}
            <button
              className="btn big"
              value="Accedi"
              onClick={
                passwordIsExpired || passwordIsWeak
                  ? () => this._resetPassword()
                  : () => this._login()
              }
            >
              Accedi
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
